import { render } from "./NewTarget.vue?vue&type=template&id=31966c20&ts=true"
import script from "./NewTarget.vue?vue&type=script&lang=ts"
export * from "./NewTarget.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__